import { useMemo, useState } from "react";
import axios from "../../../../api/axiosConfig";
import { toast } from "react-toastify";

export function usePedidoCrear(usuario, productos, navigate) {
  const [mostrarPreview, setMostrarPreview] = useState(false);
  const [mostrarErrorInventario, setMostrarErrorInventario] = useState(false);
  const [mensajeErrorInventario, setMensajeErrorInventario] = useState("");

  const [pedidoNuevo, setPedidoNuevo] = useState({
    mesa: "",
    mesero: usuario?.id || "",
    tipoPedido: "EN_MESA",
    descripcion: "",
    detalles: [],
  });

  // ➕ Agregar producto
  const agregarDetalle = () => {
    setPedidoNuevo((prev) => ({
      ...prev,
      detalles: [
        ...prev.detalles,
        {
          producto: "",
          cantidad: 1,
          precio: 0,
          subtotal: 0,
          descripcion: "",
          busqueda: "",
          sugerencias: [],
        },
      ],
    }));
  };

  const actualizarDetalle = (index, campo, valor) => {
    const copia = [...pedidoNuevo.detalles];
    copia[index][campo] = valor;

    if (campo === "producto") {
      const prod = productos.find((p) => p.id == valor);
      copia[index].precio = prod?.precio || 0;
    }

    const cantidad = Number(copia[index].cantidad || 0);
    const precio = Number(copia[index].precio || 0);
    copia[index].subtotal = cantidad * precio;

    setPedidoNuevo({ ...pedidoNuevo, detalles: copia });
  };

  const eliminarDetalle = (index) => {
    setPedidoNuevo({
      ...pedidoNuevo,
      detalles: pedidoNuevo.detalles.filter((_, i) => i !== index),
    });
  };

  const manejarBusqueda = (index, texto) => {
    const copia = [...pedidoNuevo.detalles];
    copia[index].busqueda = texto;

    copia[index].sugerencias = texto
      ? productos
          .filter((p) =>
            p.nombre.toLowerCase().includes(texto.toLowerCase())
          )
          .slice(0, 5)
      : [];

    setPedidoNuevo({ ...pedidoNuevo, detalles: copia });
  };

  const seleccionarProducto = (index, producto) => {
    if (producto.bloqueado) {
      toast.error("🚫 Producto sin stock");
      return;
    }

    const copia = [...pedidoNuevo.detalles];
    copia[index].producto = producto.id;
    copia[index].precio = producto.precio;
    copia[index].busqueda = producto.nombre;
    copia[index].sugerencias = [];
    copia[index].subtotal = producto.precio * copia[index].cantidad;

    setPedidoNuevo({ ...pedidoNuevo, detalles: copia });
  };

  const total = useMemo(
    () =>
      pedidoNuevo.detalles.reduce(
        (acc, d) => acc + Number(d.subtotal || 0),
        0
      ),
    [pedidoNuevo.detalles]
  );

  const mostrarVistaPrevia = () => {
    if (!pedidoNuevo.mesero || pedidoNuevo.detalles.length === 0) {
      toast.warning("⚠️ Completa el pedido");
      return;
    }
    setMostrarPreview(true);
  };

  const confirmarGuardarPedido = async () => {
    try {
      const body = {
        mesa:
          pedidoNuevo.tipoPedido === "EN_MESA" && pedidoNuevo.mesa
            ? { numero: pedidoNuevo.mesa }
            : null,
        mesero: { id: Number(pedidoNuevo.mesero) },
        descripcion: pedidoNuevo.descripcion || "",
        detalles: pedidoNuevo.detalles.map((d) => ({
          producto: { id: Number(d.producto) },
          cantidad: Number(d.cantidad),
          subtotal: Number(d.subtotal),
          descripcion: d.descripcion || "",
        })),
      };

      await axios.post("/pedidos", body);
      toast.success("✅ Pedido creado");
      navigate("/pedidos");
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data ||
        "Error al guardar pedido";

      if (String(msg).toLowerCase().includes("inventario")) {
        setMensajeErrorInventario(msg);
        setMostrarErrorInventario(true);
      } else {
        toast.error(msg);
      }
    }
  };

  return {
    pedidoNuevo,
    setPedidoNuevo,
    agregarDetalle,
    actualizarDetalle,
    eliminarDetalle,
    manejarBusqueda,
    seleccionarProducto,
    total,
    mostrarPreview,
    setMostrarPreview,
    mostrarVistaPrevia,
    confirmarGuardarPedido,
    mostrarErrorInventario,
    setMostrarErrorInventario,
    mensajeErrorInventario,
  };
}
